import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SZ2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SZ2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_632)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V18H0V0Z"
          fill="#3D58DB"
        />
        <path
          d="M0 3.5H-1V4.5V13.5V14.5H0H24H25V13.5V4.5V3.5H24H0Z"
          fill="#C51918"
          stroke="#FFD018"
          strokeWidth="2"
        />
        <path
          d="M5.36163 6.99846C5.27166 6.99846 5.19873 6.79506 5.19873 6.54415C5.19873 6.29325 5.27166 6.08984 5.36163 6.08984H18.4197C18.5097 6.08984 18.5826 6.29325 18.5826 6.54415C18.5826 6.79506 18.5097 6.99846 18.4197 6.99846H5.36163Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0713 6.45172L18.8296 5.48438L20.1713 6.45172L18.8296 7.4445L18.0713 6.45172Z"
          fill="#F7FCFF"
        />
        <path
          d="M5.36163 9.99846C5.27166 9.99846 5.19873 9.79506 5.19873 9.54415C5.19873 9.29325 5.27166 9.08984 5.36163 9.08984H18.4197C18.5097 9.08984 18.5826 9.29325 18.5826 9.54415C18.5826 9.79506 18.5097 9.99846 18.4197 9.99846H5.36163Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0713 9.45172L18.8296 8.48438L20.1713 9.45172L18.8296 10.4445L18.0713 9.45172Z"
          fill="#F7FCFF"
        />
        <path
          d="M3.25894 11.8664C3.13831 11.8664 3.04053 11.6354 3.04053 11.3506C3.04053 11.0657 3.13831 10.8347 3.25894 10.8347H20.7671C20.8877 10.8347 20.9855 11.0657 20.9855 11.3506C20.9855 11.6354 20.8877 11.8664 20.7671 11.8664H3.25894Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.61279 9.0397C6.61279 9.0397 8.7438 4.55469 11.7917 4.55469C14.8397 4.55469 17.0423 9.0397 17.0423 9.0397C17.0423 9.0397 14.3527 13.4658 11.8276 13.4658C9.30241 13.4658 6.61279 9.0397 6.61279 9.0397Z"
          fill="#F7FCFF"
        />
        <mask
          id="mask0_1813_632"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="6"
          y="4"
          width="12"
          height="10"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.61279 9.0397C6.61279 9.0397 8.7438 4.55469 11.7917 4.55469C14.8397 4.55469 17.0423 9.0397 17.0423 9.0397C17.0423 9.0397 14.3527 13.4658 11.8276 13.4658C9.30241 13.4658 6.61279 9.0397 6.61279 9.0397Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_632)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.943 4.26025C11.943 4.26025 11.2475 5.10491 11.4793 5.91034C11.7112 6.71578 12.2513 6.63071 12.2513 7.34003C12.2513 8.04935 12.0018 8.77276 12.2513 8.77276C12.5008 8.77276 12.5872 9.26224 12.3592 9.59409C12.1312 9.92593 11.9295 9.93619 11.943 10.4763C11.9565 11.0163 13.137 11.5465 12.5651 11.5465C11.9933 11.5465 11.2395 12.1016 11.4793 12.1016C11.7192 12.1016 12.9738 12.534 12.9738 13.1016C12.9738 13.6692 12.9738 14.1234 12.9738 14.1234H6.42822V4.26025H11.943Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.01871 7.44238H9.3445V8.76931H9.01871V7.44238ZM8.86388 7.44244H8.53809V8.76937H8.86388V7.44244ZM9.82482 7.44244H9.49902V8.76937H9.82482V7.44244ZM10.3053 7.44244H9.97949V8.76937H10.3053V7.44244ZM10.4603 7.44238H10.7861V8.76931H10.4603V7.44238ZM11.2666 7.44238H10.9409V8.76931H11.2666V7.44238ZM8.53815 9.34622H8.86394V10.6731H8.53815V9.34622ZM9.82482 9.34625H9.49902V10.6732H9.82482V9.34625ZM9.01871 9.34622H9.3445V10.6731H9.01871V9.34622ZM10.3053 9.34625H9.97949V10.6732H10.3053V9.34625ZM10.4603 9.34622H10.7861V10.6731H10.4603V9.34622ZM11.2666 9.34622H10.9409V10.6731H11.2666V9.34622Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6941 7.44238H13.3683V8.76931H13.6941V7.44238ZM12.733 7.44244H12.4072V8.76937H12.733V7.44244ZM12.8878 7.44238H13.2136V8.76931H12.8878V7.44238ZM14.1746 7.44238H13.8488V8.76931H14.1746V7.44238ZM14.3294 7.44238H14.6552V8.76931H14.3294V7.44238ZM15.1357 7.44238H14.8099V8.76931H15.1357V7.44238ZM12.4072 9.34622H12.733V10.6731H12.4072V9.34622ZM13.6941 9.34622H13.3683V10.6731H13.6941V9.34622ZM12.8878 9.34622H13.2136V10.6731H12.8878V9.34622ZM14.1746 9.34622H13.8488V10.6731H14.1746V9.34622ZM14.3294 9.34622H14.6552V10.6731H14.3294V9.34622ZM15.1357 9.34622H14.8099V10.6731H15.1357V9.34622Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.9233 5.30383C9.46693 5.44523 9.25809 6.64209 9.3091 6.93138C9.36011 7.22068 9.51495 6.89508 9.51495 6.89508C9.51495 6.89508 9.83073 7.58141 9.86329 7.76606C9.89585 7.95071 10.0622 7.48694 10.0622 7.48694C10.0622 7.48694 10.6099 7.86428 10.684 8.28474C10.7582 8.7052 10.8697 7.8036 10.8697 7.8036L10.9938 7.78172L10.9152 7.33652L11.1519 7.53885L11.0789 7.12482C11.0789 7.12482 11.2571 7.35771 11.2119 7.10137C11.1667 6.84504 11.1414 6.70193 11.1414 6.70193L11.0797 6.35156L11.3139 6.31026C11.3139 6.31026 10.3797 5.16244 9.9233 5.30383Z"
            fill="#3D58DB"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5662 10.2722C19.0922 10.3322 18.6787 11.4746 18.6787 11.7684C18.6787 12.0621 18.8877 11.7684 18.8877 11.7684C18.8877 11.7684 19.0795 12.4991 19.0795 12.6866C19.0795 12.8741 19.3239 12.4462 19.3239 12.4462C19.3239 12.4462 19.7977 12.913 19.7977 13.3399C19.7977 13.7669 20.0641 12.8983 20.0641 12.8983H20.1901V12.4462L20.388 12.6866V12.2662C20.388 12.2662 20.5231 12.5265 20.5231 12.2662C20.5231 12.0059 20.5231 11.8606 20.5231 11.8606V11.5048H20.7609C20.7609 11.5048 20.0402 10.2122 19.5662 10.2722Z"
          fill="#3D58DB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.19453 10.0989C4.66853 10.1589 5.08203 11.3013 5.08203 11.595C5.08203 11.8888 4.873 11.595 4.873 11.595C4.873 11.595 4.68119 12.3258 4.68119 12.5133C4.68119 12.7008 4.43689 12.2729 4.43689 12.2729C4.43689 12.2729 3.963 12.7396 3.963 13.1666C3.963 13.5935 3.69662 12.725 3.69662 12.725H3.57063V12.2729L3.37274 12.5133V12.0928C3.37274 12.0928 3.23768 12.3531 3.23768 12.0928C3.23768 11.8326 3.23768 11.6872 3.23768 11.6872V11.3315H2.99986C2.99986 11.3315 3.72054 10.0389 4.19453 10.0989Z"
          fill="#3D58DB"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_632">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SZ2418Icon;
